import React from 'react'
import Helmet from 'react-helmet';
import PlateComponent from './PlateComponent'
import './Top.css'
import logo from './artbox-logo-square.png'
import logo2x from './artbox-logo-square@2x.png'
import logo3x from './artbox-logo-square@3x.png'

const TopComponent = (props) => {
  return (
    <div className="Top">
    <Helmet
    htmlAttributes={{
      "prefix": "og: http://ogp.me/ns#"
    }}
    title="ART BOX"
    meta={[
      { "property": "og:type", "content": "article" }
    ]}
    />
    <div className="Top-content">
    <h1><img src={logo} srcSet={`${logo2x} 2x, ${logo3x} 3x`} alt="ART BOX ロゴ" /></h1>
    <p>ART BOX とは <a href="http://appstore.com/hiroartdirectionsinc/mandalart">MandalArt</a> および <a href="http://appstore.com/hiroartdirectionsinc/lifeart">LifeArt</a> のユーザをサポートするために、MandalArt を使って記述したコンテンツを配布するための ART（智慧）の BOX（箱）です。</p>
    <p>MandalArt や LifeArt をインストールしたけれど　Mandala をもっともっと有効に使う技術(ART) を知りたいとか　長い間使っているけれどもっと面白い使い方があるのではないかとか　他の人はどんなふうに使っているんだろうか　などなど　さまざまな要望に応えられるようなライブラリにしていきたいと考えています。</p>
    <PlateComponent />

    <div className="hint">
    <p>ART BOX は 誰でも MandalArt を使ったコンテンツを発表することが出来ます。ART BOX での発表をご希望の方は　ご遠慮なく下記へお問い合わせください。</p>
    <p><a href="mailto:martimaizumi@gmail.com">martimaizumi@gmail.com</a></p>
    </div>

    </div>
    </div>
  )
}

export default TopComponent



/** WEBPACK FOOTER **
 ** ./src/components/TopComponent.js
 **/